// LogoSplash.js
import React from 'react';
import './LogoSplash.css'; 
import Logo from './Home/Images/Logo.png'

const LogoSplash = () => {
  return (
    <div className="logo-splash">
      <img src={Logo} alt="Company Logo" className="logo" />
    </div>
  );
};

export default LogoSplash;